"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHideGeolocationUntilDate = exports.getHiddenByUser = void 0;
var _constants = require("../constants");
/**
 * Checks localStorage for information if user closed geolocation popup before.
 * If he closed it in the last month, it will return true.
 */
const getHiddenByUser = () => {
  const hideGeolocationUntilFromLocalStorage = localStorage.getItem(_constants.GEOLOCATION_LOCAL_STORAGE_KEY);
  const hideGeolocationUntil = hideGeolocationUntilFromLocalStorage ? new Date(hideGeolocationUntilFromLocalStorage) : null;
  const dateNow = new Date();
  return hideGeolocationUntil != null && hideGeolocationUntil.toString() !== 'Invalid Date' && hideGeolocationUntil >= dateNow;
};

/**
 * Sets date to localStorage to hide geolocation popup for a month.
 */
exports.getHiddenByUser = getHiddenByUser;
const setHideGeolocationUntilDate = () => {
  const dateNow = new Date();
  dateNow.setMonth(dateNow.getMonth() + 1);
  localStorage.setItem(_constants.GEOLOCATION_LOCAL_STORAGE_KEY, dateNow.toISOString());
};
exports.setHideGeolocationUntilDate = setHideGeolocationUntilDate;